import { BaseViewStore} from 'core/stores';
import { action } from "mobx";

class FacilityOrderTemplateItemNewFlowDeleteModalStore extends BaseViewStore {

    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.item = this.modalParams.data.item;
    }

    @action.bound
    async deleteItem() {
        try {
            await this.modalParams.data.deleteItem();
            this.modalParams.close();
        }
        catch (err) {
            return this.onUpdateError(err);
        }
    }
}

export default FacilityOrderTemplateItemNewFlowDeleteModalStore;
